var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { AnnualSectionTable } from '../common/annualSectionTable';
import { ExpandableTotalSection } from '../common/expandableTotalSection';
import { MultigeoLobRow } from '../common/multigeoQueuesByLob';
import { MultiskillGroupRows } from '../common/multiskillGroupRow';
import { getQueueExpansionKeysForLob, useMultiskillGroupExpansionKeys, useMultiskillGroupNames, useQueueExpansionKeys, useSelectQueuesByLobPerScenario, } from '../common/selectors';
import { getLobExpansionKey } from '../constants';
import { useSummaryByDisplayMode, useSummaryChunkSize } from '../selectors';
var TOTAL_PRODUCTION_HOURS = 'totalProductionHours';
var ProductionHoursSection = function (_a) {
    var expandedItems = _a.expandedItems, onToggleItem = _a.onToggleItem;
    var t = useTranslation('report').t;
    var data = useSummaryByDisplayMode();
    var chunkSize = useSummaryChunkSize();
    var lobsPerScenario = useSelectQueuesByLobPerScenario();
    var multiskillGroupNames = useMultiskillGroupNames(data !== null && data !== void 0 ? data : []);
    if (!data || !lobsPerScenario.length)
        return null;
    return (_jsxs(ExpandableTotalSection, __assign({ label: t('annual.totalProductionHours'), valueKey: "productionHours", expansionKey: TOTAL_PRODUCTION_HOURS, expandedItems: expandedItems, onToggleItem: onToggleItem, showVariance: true }, { children: [lobsPerScenario.map(function (lobEntry) { return (_jsx(MultigeoLobRow, { lob: lobEntry.template, perScenarioLob: lobEntry.perScenarioLob, data: data, chunkSize: chunkSize, keyItem: "productionHours", expandedItems: expandedItems, onToggleItem: onToggleItem, hideConstraintHeader: true }, lobEntry.lobName)); }), _jsx(MultiskillGroupRows, { groupNames: multiskillGroupNames, data: data, chunkSize: chunkSize, valueKey: "productionHours", showVariance: true, expandedItems: expandedItems, onToggleItem: onToggleItem })] })));
};
export var ProductionHoursTable = function () {
    var t = useTranslation('report', { keyPrefix: 'annual' }).t;
    var data = useSummaryByDisplayMode();
    var lobsPerScenario = useSelectQueuesByLobPerScenario();
    var queues = useQueueExpansionKeys(lobsPerScenario);
    var multiskillExpansionItems = useMultiskillGroupExpansionKeys(data !== null && data !== void 0 ? data : []);
    var lobs = lobsPerScenario.map(function (lobEntry) { return getLobExpansionKey(lobEntry.lobName); });
    var getNestedExpansionItems = function (itemName) {
        if (itemName === TOTAL_PRODUCTION_HOURS)
            return __spreadArray(__spreadArray(__spreadArray([], lobs, true), queues, true), multiskillExpansionItems, true);
        var lobEntry = lobsPerScenario.find(function (_a) {
            var lobName = _a.lobName;
            return getLobExpansionKey(lobName) === itemName;
        });
        if (lobEntry)
            return getQueueExpansionKeysForLob(lobEntry);
        return [];
    };
    return (_jsx(AnnualSectionTable, { title: t('productionHours'), unit: t('hours'), expansionItems: __spreadArray(__spreadArray(__spreadArray([TOTAL_PRODUCTION_HOURS], lobs, true), queues, true), multiskillExpansionItems, true), tableBodyComponent: ProductionHoursSection, getNestedExpansionItems: getNestedExpansionItems }));
};
